import React, { useState } from "react";
import * as yup from "yup";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { Report, TonnageDisclaimer } from "../../../shared";

const schema = yup.object().shape({
  manifestNumber: yup.string().max(8, "Manifest Number can only be a max of 8 characters.").when(["generatorId", "transporterId", "tsdId"], {
    is: (generatorId, transporterId, tsdId) => !generatorId && !transporterId && !tsdId,
    then: yup.string().max(12, "Manifest Number can only be a max of 12 characters.").required("A Manifest Number, Generator ID, Transporter ID, or TSD ID is required."),
    otherwise: yup.string().max(12, "Manifest Number can only be a max of 12 characters.")
  }),
  generatorId: yup.string().max(12, "Generator ID can only be a max of 12 characters.").when(["manifestNumber", "transporterId", "tsdId"], {
    is: (manifestNumber, transporterId, tsdId) => !manifestNumber && !transporterId && !tsdId,
    then: yup.string().max(12, "Generator ID can only be a max of 12 characters.").required("A Manifest Number, Generator ID, Transporter ID, or TSD ID is required."),
    otherwise: yup.string().max(12, "Generator ID can only be a max of 12 characters.")
  }),
  transporterId: yup.string().max(12, "Transporter ID can only be a max of 12 characters.").when(["manifestNumber", "generatorId", "tsdId"], {
    is: (manifestNumber, generatorId, tsdId) => !manifestNumber && !generatorId && !tsdId,
    then: yup.string().max(12, "Transporter ID can only be a max of 12 characters.").required("A Manifest Number, Generator ID, Transporter ID, or TSD ID is required."),
    otherwise: yup.string().max(12, "Transporter ID can only be a max of 12 characters.")
  }),
  tsdId: yup.string().max(12, "TSD ID can only be a max of 12 characters.").when(["manifestNumber", "generatorId", "transporterId"], {
    is: (manifestNumber, generatorId, transporterId) => !manifestNumber && !generatorId && !transporterId,
    then: yup.string().max(12, "TSD ID can only be a max of 12 characters.").required("A Manifest Number, Generator ID, Transporter ID, or TSD ID is required."),
    otherwise: yup.string().max(12, "TSD ID can only be a max of 12 characters.")
  }),
  dateFrom: yup.date(),
  dateTo: yup.date().when('dateFrom', (dateFrom, schema) => (dateFrom && schema.min(dateFrom, "Date (to) must be later than the Date (from)."))),
}, [
  ["manifestNumber", "generatorId"],
  ["manifestNumber", "transporterId"],
  ["manifestNumber", "tsdId"],
  ["generatorId", "transporterId"],
  ["generatorId", "tsdId"],
  ["transporterId", "tsdId"],
]);

function HistoricalManifestsReport() {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [initialFormValues, setInitialFormValues] = useState({
    manifestId: params && params.manifestNumber ? params.manifestNumber : "",
    generatorId: params && params.generatorId ? params.generatorId : "",
    transporterId: params && params.transporterId ? params.transporterId : "",
    tsdId: params && params.tsdId ? params.tsdId : "",
    dateTo: params && params.dateTo ? params.dateTo : "",
    dateFrom: params && params.dateFrom ? params.dateFrom : "",
  });
  const [backToUrl, setBacktoUrl] = useState("/reports");
  const [pageTitle, setPageTitle] = useState("Historical Manifests Report");
  const [apiEndpoint, setApiEndpoint] = useState(
    "/api/v1/hwts/search/historicalmanifests"
  );

  const formConfig = [
    {
      name: "manifestNumber",
      config: {
        col: "md",
        colWidth: "2",
        label: "Manifest Number",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "generatorId",
      config: {
        col: "md",
        colWidth: "2",
        label: "Generator ID",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "transporterId",
      config: {
        col: "md",
        colWidth: "2",
        label: "Transporter ID",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "tsdId",
      config: {
        col: "md",
        colWidth: "2",
        label: "TSDF ID",
        placeholder: "",
        type: "text",
      },
    },
    {
      name: "dateFrom",
      config: {
        col: "md",
        colWidth: "2",
        label: "Shipping Date (From)",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "dateTo",
      config: {
        col: "md",
        colWidth: "2",
        label: "Shipping Date (To)",
        placeholder: "",
        type: "date",
      },
    },
  ];

  const customGridCells = [
    {
      columnName: "EPA_ID",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
  ];

  const reportDescription = (
    <p>
      Provides a list of manifests submitted to DTSC prior to the year <b>2000</b>.
      <br /><br />
      <TonnageDisclaimer />
    </p>
  )

  return (
    <>
      <Report
        breadcrumb={[
          { name: "HWTS Reports", url: "/reports", active: false },
          { name: "Historical Manifest", url: "", active: true },
        ]}
        backToUrl={backToUrl}
        pageTitle={pageTitle}
        initialFormValues={initialFormValues}
        schema={schema}
        formConfig={formConfig}
        apiEndpoint={apiEndpoint}
        customGridCells={customGridCells}
        searchOnInit={searchOnInit}
      //reportDescription={reportDescription}
      />
      <div className="container">
        <TonnageDisclaimer />
      </div>
    </>
  );
}

export default HistoricalManifestsReport;
